import { render, staticRenderFns } from "./PageElementSwiper.vue?vue&type=template&id=50b1f8ec&scoped=true"
import script from "./PageElementSwiper.vue?vue&type=script&lang=js"
export * from "./PageElementSwiper.vue?vue&type=script&lang=js"
import style0 from "./PageElementSwiper.vue?vue&type=style&index=0&id=50b1f8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1f8ec",
  null
  
)

export default component.exports